<template>
  <div class="relative">
    <button class="absolute right-0 top-0 z-30" @click="saveCroppedImage">
      <tick-icon class="text-white border border-white rounded w-8" />
    </button>
    <cropper
      :src="url"
      :stencil-props="{
        aspectRatio: 1
      }"
      ref="cropper"
    />
  </div>
</template>

<script>
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';
import TickIcon from '@/components/graphics/TickIcon.vue';
import axios from 'axios';

export default {
  props: ['url', 'userId'],

  components: {
    Cropper,
    TickIcon,
  },

  data() {
    return {
      canvas: null,
    };
  },
  methods: {
    saveCroppedImage() {
      const { canvas } = this.$refs.cropper.getResult();
      const form = new FormData();
      canvas.toBlob((blob) => {
        form.append('image', blob);

        axios.post(`/api/users/${this.userId}/profile-photo`, form)
          .then(() => {
            this.createNotification('success', this.$t('upload.imgSuccess'));
            this.$emit('close');
            this.$router.go();
          })
          .catch(() => {
            this.loading = false;
            this.createNotification('error', this.$t('notifications.errorTryAgain'));
          });
      });
    },
  },

};
</script>
